import axiosInstance from "../utils/axiosInstance";
import {
  EmailLoginRequest,
  LoginResponse,
  LogoutResponse,
  SendOtpRequest,
  SendOtpResponse,
  VerifyOtpRequest,
  VerifyOtpResponse,
} from "@/types/authService";
import axios from "axios";
import { getConfig } from "@/lib/runtimeConfig";

const authService = {
  loginWithEmail: async ({ username, password, enc }: EmailLoginRequest): Promise<LoginResponse> => {
    const response = await axiosInstance.post(
      "/backend-api/auth/login",
      { username, password },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        params: { enc },
      }
    );
    return response.data;
  },
  sendOtp: async (data: SendOtpRequest): Promise<SendOtpResponse> => {
    const response = await axiosInstance.post(`/backend-api/auth/send/otp`, data);
    return response.data;
  },
  verifyOtp: async (data: VerifyOtpRequest): Promise<VerifyOtpResponse> => {
    const response = await axiosInstance.post(`/backend-api/auth/verify/otp`, data);
    return response.data;
  },
  logout: async (): Promise<LogoutResponse> => {
    const response = await axiosInstance.post("/backend-api/auth/logout");
    return response.data;
  },
  authenticateToken: async (): Promise<string> => {
    const response = await axiosInstance.post("/backend-api/auth/authenticate-token");
    return response.data;
  },
  deleteAccount: async (): Promise<string> => {
    const response = await axiosInstance.post("/backend-api/auth/delete");
    return response.data;
  },
};

export const authenticateToken = async () => {
  const response = await axios.post(
    `${getConfig("NEXT_PUBLIC_BE_BASE_URL")}/backend-api/auth/authenticate-token`,
    {},
    {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }
  );
  return { authenticated: response.status === 200 };
};

export default authService;
